// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"489":"6b1f9a15","5178":"6b1f9a15"}[chunkId] + ".chunk.css";
};